import { render, staticRenderFns } from "./NeedDigitalMarketing.vue?vue&type=template&id=1dda865b&"
import script from "./NeedDigitalMarketing.vue?vue&type=script&lang=js&"
export * from "./NeedDigitalMarketing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports